import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

interface Props {
    label: string;
    overrideLabel: string;
    inheritedFromLabel: string;
    helperText?: string;
    overrideChecked: boolean;
    onToggleOverride: (checked: boolean) => void;
    value: string;
    onChangeValue: (value: string) => void;
    inheritedValue: string;
}

export function AiExtraPromptField({ label, overrideLabel, inheritedFromLabel, helperText, overrideChecked, onToggleOverride, value, onChangeValue, inheritedValue }: Props) {
    return (
        <Box data-testid="ai-extra-prompt-field">
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.5 }}>
                <Typography variant="body2" fontWeight={500}>
                    {label}
                </Typography>
                <FormControlLabel
                    control={<Switch size="small" checked={overrideChecked} onChange={(e) => onToggleOverride(e.target.checked)} />}
                    label={overrideLabel}
                    labelPlacement="end"
                    sx={{ '& .MuiFormControlLabel-label': { fontSize: 12, color: 'text.secondary' } }}
                />
            </Stack>
            {overrideChecked ? (
                <TextField value={value} onChange={(e) => onChangeValue(e.target.value)} size="small" fullWidth multiline minRows={3} helperText={helperText} />
            ) : (
                <Box
                    sx={{
                        bgcolor: 'background.paper',
                        borderRadius: 1,
                        px: 1.5,
                        py: 1,
                        border: '1px solid',
                        borderColor: 'divider'
                    }}
                >
                    <Typography variant="body2" color="text.secondary">
                        {inheritedFromLabel}: {inheritedValue}
                    </Typography>
                </Box>
            )}
        </Box>
    );
}
